import { render, staticRenderFns } from "./BancosFormComponent.vue?vue&type=template&id=f90863d6&"
import script from "./BancosFormComponent.vue?vue&type=script&lang=js&"
export * from "./BancosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports